<template>
    <div class="CompileRun">
        <!-- 表单弹窗 -->
        <div class="from">
            <el-dialog title="编辑运营官" :visible.sync="yunyingtan" :closeOnClickModal='false' width="700px" @close="closeDialog()">
                <!-- <div class="chuangjian">编辑运营官 </div> -->
                <el-form :model="form">
                    <el-form-item label="" :label-width="formLabelWidth">
                        <div class="kuai">
                            <span class="xing">* </span>
                            运营名称:
                        </div>
                        <el-input v-model="form.operating_name" autocomplete="off" placeholder="请输入运营名称"></el-input>
                    </el-form-item>
                    <el-form-item label="" :label-width="formLabelWidth">
                        <div class="kuai">
                            <span class="xing">* </span>
                            运营联系电话:
                        </div>
                        <el-input v-model="form.operating_mobile" autocomplete="off" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="" :label-width="formLabelWidth">
                        <div class="kuai">
                            <span class="xing">* </span>
                            选择企业:
                        </div>
                        <el-select v-model="form.corporate_account_id" placeholder="请选择企业" popper-class='flock-select'>
                            <div v-infinite-scroll="load" style="" class="flock-load">
                                <el-option :label="item.corporate_account_name" :value="item.id" v-for='(item,index) in inputD' :key="index"></el-option>
                            </div>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="" :label-width="formLabelWidth" class="pitem">
                        <div class="kuai">
                            <span class="xing">* </span>
                            头像:
                        </div>
                        <!-- <el-upload class="upload-demo" drag :action="$api.upload + '?token=' + Token" :limit="2" ref="upload" list-type="picture" accept=".jpeg,.jpg,.png,.gif," show-file-list :file-list="fileListUpload" :on-remove="onRemoveupload" :on-success="onSuccessupload" :on-change="onChangeUpload">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">最多可传 1 个，扩展名为：.jpeg,.jpg,.png,.gif,</div>
                        </el-upload> -->
                        <img :src="imageUrl" alt="" class="img" v-if="dialogImageUrl==''">
                        <el-upload class="upload-demo" :action="$api.upload + '?token=' + '7ce563cc4f49544991de6ed0ac743bbe'" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-success="onSuccessupload" :on-remove="handleRemove">
                            <i class="el-icon-plus"></i>
                        </el-upload>

                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="quxiao" class="success button">取 消</el-button>
                    <el-button type="primary" @click="tijiao" class="tijiao primary button">提 交</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    props: ["msg", "id"],
    data() {
        return {
            yunyingtan: true, //操控弹窗展示
            form: {
                //表单信息
                operating_name: "",
                operating_mobile: "",
                delivery: false,
                corporate_account_name: "111111",
            },
            formLabelWidth: "140px",
            activeName: "", //显示组件
            imageUrl: "", //头像
            fileListUpload: [], //上传的文件列表
            dialogImageUrl: "",
            dialogVisible: false,
            page: 1,
            inputD: "",
        };
    },
    mounted() {
        this.getTopOperatingRes(); //获取运营官
        // this.getTopCorporateAccountList(); //获取企业
        if (this.msg == CompileRun) {
            this.activeName == true;
        }
    },
    methods: {
        handleRemove(file, fileList) {
            this.dialogImageUrl = "";
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePictureCardPreview(file) {
            window.open(
                "https://user.erlangcha.com/advances/Advimage?imageurl=" +
                    this.dialogImageUrl
            );
        },
        // 获取企业信息
        getTopCorporateAccountList() {
            var param = {
                page: this.page,
            };
            this.$service.get(
                this.$api.getTopCorporateAccountList,
                param,
                (res) => {
                    if (res.code == "200") {
                        this.inputD = res.data.data;
                        // console.log(this.inputD);
                    }
                }
            );
        },
        // 获取编辑运营官信息
        getTopOperatingRes() {
            var param = {
                operating_id: this.id,
            };
            // console.log(param);
            this.$service.get(this.$api.getTopOperatingRes, param, (res) => {
                if (res.code == "200") {
                    this.imageUrl = res.data.upload_img;
                    this.form = res.data;
                }
            });
        },
        //选择企业触底事件
        load() {
            this.page += 1;
            var param = {
                page: this.page,
            };
            this.$service.get(
                this.$api.getTopCorporateAccountList,
                param,
                (res) => {
                    var data = res.data.data;
                    if (data == "") {
                        this.$message({
                            message: "已没有更多数据",
                            type: "warning",
                        });
                        return;
                    }
                    if (res.code == "200") {
                        var inputD = this.inputD;
                        data.forEach(function (item, index) {
                            inputD.push(item);
                        });
                        this.inputD = inputD;
                    }
                }
            );
        },
        quxiao() {
            this.$emit("yunying");
            this.yunyingtan = false;
        },
        closeDialog() {
            this.$emit("yunying");
            this.yunyingtan = false;
        },
        // 提交编辑
        tijiao() {
            var param = this.form;
            var operating_id = this.id;
            delete param.updated_at;
            delete param.created_at;
            delete param.id;
            delete param.is_del;
            // console.log(param)
            param.operating_id = operating_id;
            if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(param.operating_mobile)) {
                this.$message({ message: "请正确输入手机号", type: "warning" });
            } else {
                this.$service.post(
                    this.$api.createTopOperating,
                    param,
                    (res) => {
                        if (res.code == "200") {
                            this.$message({
                                message: "编辑成功",
                                type: "success",
                            });
                            this.$emit("bianji");
                            this.yunyingtan = false;
                            // console.log(res);
                        }
                    }
                );
            }
        },

        //上传文件移出
        onRemoveupload(file, fileList) {
            // console.log("上传文件移出", fileList);
            this.fileListUpload = fileList;
            this.file_id = "";
            this.$message({
                message: "文件移出成功，请重新上传文件",
                type: "success",
            });
        },
        //文件上传成功
        onSuccessupload(res, file, fileList) {
            this.dialogImageUrl = res.data.file_url;
            this.form.upload_img=res.data.file_url;
            this.form.file_id = res.data.id;
            this.imageUrl = res.data.file_url;
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
            if (res.code == 200) {
                this.file_id = res.data.id;
            }
        },
        //文件上传成功，失败 所有都会调用
        onChangeUpload(file, fileList) {
            // if (fileList.length > 1) {
            // 	fileList.splice(1, 1);
            // }
            // console.log(file, "文件上传成功，失败 所有都会调用");
        },
    },
};
</script>

<style lang="scss" scoped>
.CompileRun {
    .chuangjian {
        // height: 40px;
        line-height: 40px;
    }
    .xing {
        color: red;
        margin-right: 6px;
    }
    .kuai {
        width: 140px;
        display: inline-block;
    }
    .tijiao {
        margin-left: 40px;
    }
    // .button {
    //     width: 90px;
    //     color: #ffffff;
    // }
    .img {
        width: 148px;
        height: 148px;
        margin-right: 20px;
    }
    //
}
</style>
<style lang="scss">
.CompileRun {
    .upload-demo {
        display: inline-block;
    }
    .el-upload-dragger {
        height: 150px;
    }
    .el-upload__tip {
        width: 250px;
    }
    .el-dialog__header {
        background: #0075f7;
    }
    .el-dialog__title {
        color: #ffffff;
    }
    .el-form-item__content {
        display: flex;
    }
}
</style>